module.exports = __webpack_public_path__ + "static/media/line-chart.a815caef.png";